import { initWxConfig } from '@/config/wxConfig';
import { WX_SHARE_DEFAULT_DATA } from '@/config/index';
import store from '@/store/index';

/**
 * @description 自定义分享内容
 * @param {object} data
 * @param {string} data.title
 * @param {string} data.desc
 * @param {string} data.link
 * @param {string} data.imgUrl
 */
export default async function wxShare(data = {}) {
  // if (!store.state.isIosInitWxSDK) {  // 此处重复了初始化，影响莓塔支付
  //   await initWxConfig();
  // }

  // eslint-disable-next-line no-undef
  wx.ready(() => {
    const shareData = Object.assign(WX_SHARE_DEFAULT_DATA, data);

    // eslint-disable-next-line no-undef
    wx.updateAppMessageShareData({
      title: shareData.title, // 分享标题
      desc: shareData.desc, // 分享描述
      link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.imgUrl, // 分享图标
      success() {
        console.error('wx: updateAppMessageShareData.');
      }
    });

    // eslint-disable-next-line no-undef
    wx.updateTimelineShareData({
      title: shareData.title, // 分享标题
      link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.imgUrl, // 分享图标
      success() {
        console.error('wx: updateTimelineShareData.');
      }
    });
  });
}
